import { Directive, HostBinding, input } from '@angular/core';

import { InputSize } from './input.model';

@Directive({
	standalone: true,
	selector: 'input[slInput]',
})
export class InputDirective {
	readonly size = input<InputSize>(InputSize.Auto);

	@HostBinding('class') get inputClasses(): string[] {
		return ['sl-input', 'sl-input--' + this.size()];
	}
}
